import template from './page-home-video.html';
import controller from './page-home-video.controller';
import './page.scss';

let pageHomeVideoComponent = {
  bindings: {},
  template,
  controller
};

export default pageHomeVideoComponent;


// WEBPACK FOOTER //
// ./client/app/components/page/page-home-video.component.js